<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <!-- 卡片主体(表单) -->
          <div class="md-layout card-form">
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <md-select v-model="formData.type">
                  <md-option :value="0">{{$I18n('all')}}</md-option>
                  <md-option :value="1">{{$I18n('quectel')}}</md-option>
                  <md-option :value="2">{{$I18n('dxy')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout md-layout-item md-size-20">
              <div class="md-layout-item md-size-25">
                <md-button class= "left-icon md-info" @click="form_changeSearchData">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_platform")}}</add-button>
          <!-- 卡片主体(表格) -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">
                {{ item.type_name }}
              </md-table-cell>
              <md-table-cell :md-label="'APP key'">
                {{ item.app_key }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('app_secret')">
                {{ item.app_secret }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box"> 
                <md-button
                  @click.stop="table_repull(item)"
                  class="md-just-icon md-round md-info left-icon"
                  ><md-icon>autorenew</md-icon></md-button
                >
                <md-button
                  @click.stop="table_editItem(item)"
                  class="md-just-icon md-round md-info"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click.stop="table_deleteItem(item)"
                  class="md-just-icon md-round md-danger left-icon"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :large = "openModalType==='import'"
      :right = "openModalType!=='delete'"
      :submitBtn = "openModalType !=='import'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";

export default {
  data() {
    return {
      // 表格相关
      ...({
        formData:{
          type : 0,
        },
        searchData : {
          type : 0,
        },
        icon  : "computer",
        title : this.$I18n("setting_flow"),
        tableInitData : [], // 表格数据
        compData : [], // 公司数据
        // 分页相关
        pageSize : 10,
        currentPage : 1,
        total : 0,
        // 弹窗相关
        openModal: false,  // 是否打开弹窗
        openModalType : "upload", // 弹窗类型
        modalTitle : "",  // 弹窗标题
      }),
      // 弹窗表单相关
      ...({
        modalData: new FormClass({
          comp_id : this.UserInfo.comp_id,
          name  : "",
          app_key : "",
          app_secret  : "",
          type : 1,
        },{
          name      : "required",
          app_key   : "required",
          app_secret: "required",
        }),
      })
    };
  },
  mounted : function() {
    this.api_getPageData();
    this.api_getComp().then(() => {
      // this.modalData.SetInit(this.compData[0].comp_id, "comp_id")
    });
  },
  watch: {
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            let type_name = "";
            switch(item.type){
              case 1:
                type_name = this.$I18n("quectel");
                break;
              case 2:
                type_name = this.$I18n("dxy");
                break;

              default:
                type_name = this.$I18n("unknow");
                break;
            }
            return {
              type_name,
              ... item,
            }
          })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          placeholder: this.$I18n('pls_input_role_id'),
        },{
          label   : "APP key",
          keys    : "app_key",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("app_secret"),
          keys    : "app_secret",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("platform_type"),
          keys    : "type",
          type    : "select",
          options : [{
            id: "1",
            name : this.$I18n("quectel"),
          },{
            id: "2",
            name : this.$I18n("dxy"),
          }],
        },
      ]
    },
  },
  methods: {
    form_changeSearchData(){
      this.searchData = {...this.formData}
      this.currentPage = 1;
      this.api_getPageData();
    },
    table_addItem(){
      this.modalTitle = this.$I18n("add");
      this.modalData.Reset();
      this.openModalType = "add";
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modalTitle = this.$I18n("edit");
      this.modalData.Update(item);
      this.openModalType = "edit";
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modalTitle = this.$I18n("delete");
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.$refs.modal.open();
    },
    table_repull(item){
      this.$api.goodPull({
        id: item.id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("refresh_succ"));
        }))
        .catch(this.$Catch(this.$I18n("refresh_fail")))
    },
    // 获取公司信息
    api_getComp (){
      //获取菜单
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      this.$api.getOtherPlatformInfo(this.searchData)
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.data.length;
        }))
        .catch(this.$Catch("",() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 提交表单
    modal_submit () {
      if (this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_input_content"));
        return;
      }
      // let opcode = 1;
      if(this.openModalType === "add"){
        this.$api.addOtherPlatformInfo({
          ...this.modalData.Form,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "edit"){
        this.$api.editOtherPlatformInfo({
          ...this.modalData.Form,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType === "delete"){
        this.$api.delOtherPlatformInfo({
          ...this.modalData.Form,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getPageData();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 180px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>